import { forwardRef } from 'react';
import classNames from 'classnames';
import getNativeClassNameStyle from '../../helpers/getNativeClassNameStyle';
import styles from './Txt.module.scss';

/**
 * Txt
 *
 * @return {JSX.Element}
 */
const Txt = (
  {
    className,
    style,
    bold,
    italic,
    regular,
    noWrap,
    right,
    error,
    x,
    xx,
    xxx,
    xxxx,
    xxxxx,
    m,
    mm,
    mmm,
    caption,
    uppercase,
    reverse,
    white,
    ...rest
  },
  ref
) => {
  const [localClassName, localStyle] = getNativeClassNameStyle(
    className,
    style
  );

  return (
    <span
      className={classNames(
        styles.Txt,
        bold && styles.Txt__bold,
        italic && styles.Txt__italic,
        regular && styles.Txt__regular,
        uppercase && styles.Txt__uppercase,
        x && styles.Txt__x,
        xx && styles.Txt__xx,
        xxx && styles.Txt__xxx,
        xxxx && styles.Txt__xxxx,
        xxxxx && styles.Txt__xxxxx,
        m && styles.Txt__m,
        mm && styles.Txt__mm,
        mmm && styles.Txt__mmm,
        caption && styles.Txt__caption,
        noWrap && styles.Txt__noWrap,
        right && styles.Txt__right,
        error && styles.Txt__error,
        reverse && styles.Txt__reverse,
        white && styles.Txt__white,
        localClassName,
        Txt.displayName
      )}
      style={localStyle}
      ref={ref}
      {...rest}
    />
  );
};

Txt.displayName = 'Txt';

export default forwardRef(Txt);
